// src/pages/roleManagement.js
import React from "react";

import NavBar from "../components/NavBar/NavBar";
import RoleManagement from "../components/RoleManagement/RoleManagement";

export default function RolePage() {
  return (
    <>
      <NavBar/>
      <main className="web-view">
   <RoleManagement />
      </main>
    </>
  );
}